export var toKebabCase = function toKebabCase(str) {
  var matched = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g);

  if (matched) {
    return matched.map(function (x) {
      return x.toLowerCase();
    }).join("-");
  }

  return str;
};